<template>
  <div>
    <v-card>
      <!-- Cabeçalho -->
      <v-card-title class="mb-2">
        <v-chip color="primary" label text-color="white">
          Nova Plataforma
        </v-chip>
      </v-card-title>

      <v-card-text>
        <!-- Abas -->
        <v-tabs v-model="selectedTab" grow>
          <v-tab>Dados</v-tab>
          <v-tab>Preview</v-tab>
        </v-tabs>

        <!-- Conteúdo das Abas -->
        <v-tabs-items v-model="selectedTab">
          <v-tab-item>
            <div class="pa-4">
              <v-form ref="form">
                <v-stepper
                  v-model="currentStep"
                  vertical
                  elevation="0"
                >
                  <v-stepper-step :complete="isBasicInfoComplete" step="1">
                    Informações Básicas
                  </v-stepper-step>
                  <v-stepper-content step="1">
                    <basic-info-step
                      v-model="platform"
                      ref="basicInfoStep"
                    >
                      <template #actions>
                        <stepper-actions
                          @back="$emit('close')"
                          @next="toNextStep"
                          :disable-next="!isBasicInfoComplete"
                          back-label="Cancelar"
                        />
                      </template>
                    </basic-info-step>
                  </v-stepper-content>

                  <!-- Passo 2: Informações Legais -->
                  <v-stepper-step :complete="isLegalInfoComplete" step="2">
                    Informações Legais
                  </v-stepper-step>
                  <v-stepper-content step="2">
                    <legal-info-step
                      v-model="platform"
                      ref="legalInfoStep"
                    >
                      <template #actions>
                        <v-btn text @click="toPreviousStep">Voltar</v-btn>
                        <v-btn
                          color="primary"
                          @click="toNextStep"
                          :disabled="!isLegalInfoComplete"
                        >
                          Próximo
                        </v-btn>
                      </template>
                    </legal-info-step>
                  </v-stepper-content>

                  <!-- Passo 3: Redes Sociais -->
                  <v-stepper-step :complete="hasSocialNetworks" step="3">
                    Redes Sociais
                  </v-stepper-step>
                  <v-stepper-content step="3">
                    <social-networks-step
                      v-model="platform"
                      ref="socialNetworksStep"
                    >
                      <template #actions>
                        <v-btn text @click="toPreviousStep">Voltar</v-btn>
                        <v-btn
                          color="primary"
                          @click="toNextStep"
                        >
                          Próximo
                        </v-btn>
                      </template>
                    </social-networks-step>
                  </v-stepper-content>

                  <!-- Passo 4: Cores -->
                  <v-stepper-step :complete="isColorsComplete" step="4">
                    Cores
                  </v-stepper-step>
                  <v-stepper-content step="4">
                    <colors-step
                      v-model="platform"
                      ref="colorsStep"
                    >
                      <template #actions>
                        <v-btn text @click="toPreviousStep">Voltar</v-btn>
                        <v-btn
                          color="primary"
                          @click="toNextStep"
                          :disabled="!isColorsComplete"
                        >
                          Próximo
                        </v-btn>
                      </template>
                    </colors-step>
                  </v-stepper-content>

                  <!-- Passo 5: Logos -->
                  <v-stepper-step :complete="hasLogos" step="5">
                    Logos
                  </v-stepper-step>
                  <v-stepper-content step="5">
                    <logos-step
                      v-model="platform"
                      ref="logosStep"
                    >
                      <template #actions>
                        <v-btn text @click="toPreviousStep">Voltar</v-btn>
                        <v-btn color="primary" @click="toNextStep">
                          Próximo
                        </v-btn>
                      </template>
                    </logos-step>
                  </v-stepper-content>

                  <!-- Passo 6: Configurações Adicionais -->
                  <v-stepper-step step="6">
                    Configurações Adicionais
                  </v-stepper-step>
                  <v-stepper-content step="6">
                    <v-card outlined class="pa-4 mb-3">
                      <v-switch
                        v-model="platform.hidePoweredBy"
                        label="Ocultar 'Powered By'"
                        outlined
                        dense
                      />
                    </v-card>

                    <v-btn text @click="toPreviousStep">Voltar</v-btn>
                    <v-btn color="primary" @click="goToPreview">
                      Preview
                    </v-btn>
                  </v-stepper-content>
                </v-stepper>
              </v-form>
            </div>
          </v-tab-item>

          <!-- ABA PREVIEW -->
          <v-tab-item>
            <platform-preview 
              :platform="platform" 
              :preview-images="previewImages"
              @back="selectedTab = 0"
              @save="save"
              :loading="loading"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";
import BasicInfoStep from '@/components/admin/platform/steps/BasicInfoStep.vue'
import LegalInfoStep from '@/components/admin/platform/steps/LegalInfoStep.vue'
import SocialNetworksStep from '@/components/admin/platform/steps/SocialNetworksStep.vue'
import ColorsStep from '@/components/admin/platform/steps/ColorsStep.vue'
import LogosStep from '@/components/admin/platform/steps/LogosStep.vue'
import StepperActions from '@/components/admin/platform/steps/StepperActions.vue'
import PlatformPreview from '@/components/admin/platform/PlatformPreview.vue'

export default {
  name: "CreatePlatform",
  components: {
    BasicInfoStep,
    LegalInfoStep,
    SocialNetworksStep,
    ColorsStep,
    LogosStep,
    StepperActions,
    PlatformPreview
  },
  props: {
    value: Boolean,
  },
  data: () => ({
    loading: false,
    selectedTab: 0,
    currentStep: 1,
    socialTypes: [
      { text: "Instagram", value: "ig" },
      { text: "Twitter", value: "tw" },
      { text: "TikTok", value: "tt" },
      { text: "Facebook", value: "fb" },
      { text: "YouTube", value: "yt" },
    ],
    platform: {
      name: "",
      domain: "",
      email: "",
      phone: "",
      legalInfo: {
        document: "",
        legalName: "",
        fantasyName: "",
      },
      socialNetworks: [],
      hidePoweredBy: false,
      colors: {
        dark: {
          primary: "#003cfa",
          secondary: "#35ec61",
          brandPrimary: "#6462e7",
          brandSecondary: "#0d8adc",
        },
        light: {
          primary: "#003cfa",
          secondary: "#35ec61",
          brandPrimary: "#6462e7",
          brandSecondary: "#0d8adc",
        },
        appBar: "#272737",
        footerBar: "#272737",
      },
      logos: {
        dark: "",
        light: "",
        folks: "",
        favicon: "",
        background: "",
        videoCover: "",
      },
      active: true,
    },
    previewImages: {
      dark: null,
      light: null,
      folks: null,
      favicon: null,
      background: null,
      videoCover: null,
    },
    rules: {
      required: (v) => !!v || "Campo obrigatório",
      email: (v) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(v) || "E-mail inválido";
      },
      phone: (v) => {
        const pattern = /^\(\d{2}\) \d{5}-\d{4}$/;
        return pattern.test(v) || "Telefone inválido";
      },
      cnpj: (v) => {
        const pattern = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
        if (!pattern.test(v)) return "CNPJ inválido";

        const numbers = v.replace(/[^\d]/g, "");
        if (numbers.length !== 14) return "CNPJ inválido";
        if (/^(\d)\1+$/.test(numbers)) return "CNPJ inválido";

        // Primeiro dígito verificador
        let sum = 0;
        let weight = 2;
        for (let i = 11; i >= 0; i--) {
          sum += parseInt(numbers.charAt(i)) * weight;
          weight = weight === 9 ? 2 : weight + 1;
        }
        let digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        if (parseInt(numbers.charAt(12)) !== digit) return "CNPJ inválido";

        // Segundo dígito verificador
        sum = 0;
        weight = 2;
        for (let i = 12; i >= 0; i--) {
          sum += parseInt(numbers.charAt(i)) * weight;
          weight = weight === 9 ? 2 : weight + 1;
        }
        digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        if (parseInt(numbers.charAt(13)) !== digit) return "CNPJ inválido";

        return true;
      },
    },
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isBasicInfoComplete() {
      return !!(
        this.platform.name &&
        this.platform.domain &&
        this.platform.email &&
        this.platform.phone
      );
    },
    isLegalInfoComplete() {
      return !!(
        this.platform.legalInfo.document &&
        this.platform.legalInfo.legalName &&
        this.platform.legalInfo.fantasyName
      );
    },
    isColorsComplete() {
      return !!(
        this.platform.colors.dark.primary &&
        this.platform.colors.dark.secondary &&
        this.platform.colors.light.primary &&
        this.platform.colors.light.secondary
      );
    },
    hasSocialNetworks() {
      return (
        this.platform.socialNetworks.length > 0 &&
        this.platform.socialNetworks.every(
          (social) => social.url && social.type
        )
      );
    },
    hasLogos() {
      const logos = this.platform.logos;
      // Retorna true se pelo menos um logo tiver link
      return !!(
        logos.dark ||
        logos.light ||
        logos.folks ||
        logos.favicon ||
        logos.background ||
        logos.videoCover
      );
    },
  },
  methods: {
    toNextStep() {
      if (this.currentStep < 6) {
        this.currentStep++;
      }
    },
    toPreviousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    goToPreview() {
      if (this.$refs.form.validate()) {
        this.selectedTab = 1;
      }
    },
    addSocialNetwork() {
      this.platform.socialNetworks.push({ url: "", type: "ig" });
    },
    removeSocialNetwork(index) {
      this.platform.socialNetworks.splice(index, 1);
    },
    getLogoLabel(type) {
      const labels = {
        dark: "Logo Modo Escuro",
        light: "Logo Modo Claro",
        folks: "Logo Folks",
        favicon: "Favicon",
        background: "Imagem de Fundo",
        videoCover: "Vídeo de Capa",
      };
      return labels[type];
    },
    openFileInput(type) {
      this.$refs["fileInput_" + type][0].$refs.input.click();
    },
    async onFileSelected(file, type) {
      if (!file) return;

      try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await platformService.uploadTempLogo(formData);

        if (response && response.success) {
          this.platform.logos[type] = response.location;
          this.previewImages[type] = response.location;
        }
      } catch (error) {
        console.error("Erro ao enviar logo:", error);
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await platformService.create(this.platform);
          this.$router.push({ name: 'admin.platforms' });
          this.$toast.success('Plataforma criada com sucesso!');
        } catch (error) {
          console.error(error);
          this.$toast.error(error.message || "Erro ao salvar plataforma");
        } finally {
          this.loading = false;
        }
      }
    },
    formatPhone(value) {
      if (!value) return "";
      value = value.replace(/\D/g, "");
      if (value.length > 11) value = value.slice(0, 11);

      if (value.length > 6) {
        this.platform.phone = `(${value.slice(0, 2)}) ${value.slice(
          2,
          7
        )}-${value.slice(7)}`;
      } else if (value.length > 2) {
        this.platform.phone = `(${value.slice(0, 2)}) ${value.slice(2)}`;
      } else if (value.length > 0) {
        this.platform.phone = `(${value}`;
      } else {
        this.platform.phone = value;
      }
    },
    formatCNPJ(value) {
      if (!value) return "";
      value = value.replace(/\D/g, "");
      if (value.length > 14) value = value.slice(0, 14);

      if (value.length > 12) {
        this.platform.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2,
          5
        )}.${value.slice(5, 8)}/${value.slice(8, 12)}-${value.slice(12)}`;
      } else if (value.length > 8) {
        this.platform.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2,
          5
        )}.${value.slice(5, 8)}/${value.slice(8)}`;
      } else if (value.length > 5) {
        this.platform.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2,
          5
        )}.${value.slice(5)}`;
      } else if (value.length > 2) {
        this.platform.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2
        )}`;
      } else {
        this.platform.legalInfo.document = value;
      }
    },
  },
};
</script>

<style scoped>
.logo-upload-area {
  width: 100%;
  height: 200px;
  border: 2px dashed #ccc;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.logo-upload-area:hover {
  border-color: var(--v-primary-base);
  background-color: #f0f0f0;
}

/* Exemplo de como controlar altura mínima do banner se desejar */
.banner-preview {
  min-height: 200px;
}

/* Ajustes de layout se quiser refinar mais a "header-preview" */
.header-preview {
  min-height: 100px;
}
</style>
  